import { render, staticRenderFns } from "./HouseUpdate.vue?vue&type=template&id=b9af0b1c&scoped=true&"
import script from "./HouseUpdate.vue?vue&type=script&lang=js&"
export * from "./HouseUpdate.vue?vue&type=script&lang=js&"
import style0 from "./HouseUpdate.vue?vue&type=style&index=0&id=b9af0b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9af0b1c",
  null
  
)

component.options.__file = "HouseUpdate.vue"
export default component.exports